import { IconProps } from 'types/icon.type'

export const FacebookIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Facebook Logo</title>
      <path
        d="M9.60002 21.5999V11.9999H6.40002V8.7999H9.60002V7.0815C9.60002 3.8279 11.1848 2.3999 13.8888 2.3999C15.184 2.3999 15.8688 2.4959 16.1928 2.5399V5.5999H14.3488C13.2008 5.5999 12.8 6.2055 12.8 7.4327V8.7999H16.164L15.7072 11.9999H12.8V21.5999H9.60002Z"
        fill="currentColor"
      />
    </svg>
  )
}
